// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__57jNV","modalClose":"Modal_modalClose__bzTuH"};